import Whisper from './Whisper';
import withLocale from '../IntlProvider/withLocale';
export default withLocale([])(Whisper);